import React, { useState } from "react";
import "../styles/Testimonials.css";

const testimonials = [
  {
    text: "I’m pleased to recommend my classmate Geetha Sagar Bonthu for analytics roles. I collaborated with Geetha on multiple Kaggle competitions and group projects; he consistently demonstrated strong analytics skills, a solid understanding of machine learning algorithms, and a sharp problem‑solving mindset. He’s highly curious, explores multiple approaches to extract insights, and is dedicated to seeing tasks through. I highly recommend him for data and analytics roles.",
    quote: "Highly curious, explores multiple approaches, and sees tasks through.",
    author: "Siddhant Madan",
    title: "Senior Data Engineer",
    company: ""
  },
  {
    text: "In the time I worked with Geetha, I came to find that he was insightful, hardworking, extremely competent,and a great listener. The project we worked on together came with many challenges: understanding our client’s needs, adapting our approach to fit the client’s goals, and often times starting over nearly from scratch to adapt our work to changing goals. Geetha handled all of this excellently, and his technical expertise was essential to delivering actionable business insights. Much of the foundational work we needed to understand our client’s data was done by Geetha, and without his hard work it would have been much harder to even get started on our project. He was an excellent communicator and took constructive criticism very well, if work he did needed changes he was quick to respond and rarely needed to make changes more than once. As a team member he was vital to our group’s work and I cannot recommend working with him enough. He would make a great addition to any analytics team.",
    quote: "His technical expertise was essential to delivering actionable insights.",
    author: "Ethan Bayer",
    title: "Analyst",
    company: ""
  }
  ,
  {
    text: "I worked with Sagar at the University of Cincinnati Marketing Lab, where he was part of the team as a Data Analyst. We collaborated on several projects that involved working through data to support marketing research and insights. Sagar is someone who’s genuinely comfortable with data. Whether it was cleaning datasets, digging into patterns, or making sense of results, he approached the work thoughtfully and made sure the analysis actually answered the questions we were trying to solve. He paid attention to details but also kept the bigger picture in mind. He’s also very easy to work with — communicates clearly, is open to feedback, and takes ownership of his work. Collaboration with him always felt smooth, and he was someone the team could count on to get things done without unnecessary back and forth. I’d strongly recommend Geetha Sagar Bonthu for Data Analyst or analytics-focused roles.",
    quote: "Made sure the analysis answered the questions we were solving.",
    author: "Bala Manish Reddy Thumma",
    title: "Senior Software Engineer",
    company: ""
  }
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-header">
        <h2 className="section-title">What People Say</h2>
        <p className="section-sub">Recommendations and endorsements</p>
      </div>

      <div className="testimonials-grid">
        {testimonials.map((recommendation, index) => (
          <RecommendationCard key={recommendation.author} recommendation={recommendation} index={index} />
        ))}
      </div>
    </section>
  );
}

function RecommendationCard({ recommendation, index }) {
  const [expanded, setExpanded] = useState(false);
  const textId = `recommendation-${index}`;

  return (
    <blockquote className="testimonial-card">
      <p className="testimonial-quote">“{recommendation.quote}”</p>
      <p id={textId} className={`testimonial-text${expanded ? " expanded" : ""}`}>
        {recommendation.text}
      </p>
      <button
        type="button"
        className="recommendation-toggle"
        aria-expanded={expanded}
        aria-controls={textId}
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? "Read less" : "Read more"}
      </button>
      <footer className="testimonial-meta">
        <span className="testimonial-author">{recommendation.author}</span>
        {recommendation.title && <span className="testimonial-role">{recommendation.title}</span>}
      </footer>
    </blockquote>
  );
}
